import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import baseQuery from "../../utils/baseQuery";

export interface Zutat {
    id: number
    name: string
    kategorie: number | null
}

export interface Kategorie {
    id: number,
    name: string,
    sort_id: number
}

export const zutatenApi = createApi({
    reducerPath: "zutaten",
    baseQuery: baseQuery,
    tagTypes: ["zutaten", "kategorien"],
    endpoints: builder => ({
        listZutaten: builder.query<Zutat[], void>({
            query: () => "zutaten/",
            providesTags: () => [{ type: "zutaten" }]
        }),
        listKategorien: builder.query<Kategorie[], void>({
            query: () => "kategorien/",
            providesTags: () => [{ type: "kategorien" }]
        }),
        addZutat: builder.mutation<Zutat, string>({
            query: name => ({
                url: `zutaten/`,
                params: { name },
                method: "POST",
            }),
            invalidatesTags: () => [{ type: "zutaten" }]
        }),
        setKategorie: builder.mutation<void, { zutatId: number, kategorie: number | null }>({
            query: ({ zutatId, kategorie }) => ({
                url: `zutaten/${zutatId}/kategorie`,
                params: { kategorie: kategorie ?? undefined },
                method: "PUT",
            }),
            invalidatesTags: () => [{ type: "zutaten" }]
        }),
        addKategorie: builder.mutation<void, { name: string }>({
            query: ({ name }) => ({
                url: "kategorien",
                params: { name },
                method: "POST",
            }),
            invalidatesTags: () => [{ type: "kategorien" }],
        }),
        removeKategorie: builder.mutation<void, { id: number }>({
            query: ({ id }) => ({
                url: `kategorien/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: () => [{ type: "kategorien" }],
        }),
        setKategorieName: builder.mutation<void, { id: number, name: string }>({
            query: ({ id, name }) => ({
                url: `kategorien/${id}/name`,
                method: "PUT",
                params: { name },
            }),
            invalidatesTags: () => [{ type: "kategorien" }],
        }),
        setKategorieSortId: builder.mutation<void, { id: number, sortId: number }>({
            query: ({ id, sortId }) => ({
                url: `kategorien/${id}/sortId`,
                method: "PUT",
                params: { sortId },
            }),
            invalidatesTags: () => [{ type: "kategorien" }]
        }),
    })
});

export const {
    useListZutatenQuery,
    useListKategorienQuery,
    useAddZutatMutation,
    useSetKategorieMutation,
    useAddKategorieMutation,
    useRemoveKategorieMutation,
    useSetKategorieNameMutation,
    useSetKategorieSortIdMutation
} = zutatenApi;
